import React from 'react'
import { Tooltip, Row, Table } from 'antd'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import ReactTimeAgo from 'react-time-ago/commonjs/ReactTimeAgo'
import { loadRecentBlocks } from '@/actions/home'
import theme from '@/styles/theme'
import PageHeader from '@/v2/components/PageHeader'
import Label from '@/v2/components/Label'

class RecentBlocks extends React.Component {
  componentDidMount() {
    this.props.loadRecentBlocks()
  }

  columns = [
    {
      key: 'block',
      render: ({ num }) => (
        <React.Fragment>
          <Label>Block: </Label>
          <Link to={`/block/${num}`} style={{ fontWeight: 'bold' }}>
            {num}
          </Link>
        </React.Fragment>
      ),
      width: '20%',
    },
    {
      key: 'include',
      render: ({ num_of_txs }) => (
        <React.Fragment>
          <Label>Include: </Label>
          <b>{num_of_txs} Transactions</b>
        </React.Fragment>
      ),
      width: '25%',
    },
    {
      key: 'reward',
      render: () => (
        <Tooltip title="128 WEL as block rewards, and 64 WEL as voting rewards.">
          <Label>Reward: </Label>
          <b>192</b>
        </Tooltip>
      ),
      width: '20%',
    },
    {
      key: 'producer',
      render: ({ witness_address, witness_name }) => (
        <React.Fragment>
          <Label>Producer: </Label>
          <Link
            to={`/accounts/${witness_address}`}
            style={{ color: theme.colors.white, fontWeight: 'bold' }}
          >
            {witness_name
              ? witness_name
              : witness_address.substring(0, 3) +
                '...' +
                witness_address.substring(31, witness_address.length)}
          </Link>
        </React.Fragment>
      ),
      width: '20%',
    },
    {
      key: 'age',
      render: ({ timestamp }) => (
        <Label>
          {timestamp ? <ReactTimeAgo date={new Date(timestamp)} locale="en-US" /> : 'unknown'}
        </Label>
      ),
      width: '15%',
    },
  ]

  render() {
    const blocks = this.props.blocks ?? []
    blocks.sort(function (a, b) {
      return b.num - a.num
    })

    return (
      <>
        <Row align="middle" justify="space-between">
          <PageHeader>Recent Blocks</PageHeader>
          <Link to="/blocks">more &gt;</Link>
        </Row>
        <Table
          rowKey={(record) => record.timestamp}
          columns={this.columns}
          dataSource={blocks.slice(0, 6)}
          showHeader={false}
          pagination={false}
          loading={blocks.length === 0 ? true : false}
          scroll={{ x: 768 }}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    blocks: state.homeBlocks.blocks,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    loadRecentBlocks: () => {
      dispatch(loadRecentBlocks())
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(RecentBlocks)
